import Vue from 'vue';
import App from './App.vue';
import store from './Store/index.js'
import router from "./Router";
import Configs from "./Configs";

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  data: {
    Configs,
  },
  render: h => h(App),
}).$mount('#body__wrapper');
